import { APP_INITIALIZER, Injectable, InjectionToken, Injector, NgModule } from '@angular/core';

var DEFAULT_COUNTER_ID_AOT = new InjectionToken('DEFAULT_COUNTER_ID_AOT');
var DEFAULT_COUNTER_ID = new InjectionToken('DEFAULT_COUNTER_ID');
var YANDEX_COUNTERS_CONFIGS_AOT = new InjectionToken('YANDEX_COUNTERS_CONFIGS_AOT');
var YANDEX_COUNTERS_CONFIGS = new InjectionToken('YANDEX_COUNTERS_CONFIGS');
var YandexCounterConfig = (function () {
    function YandexCounterConfig() {
        this.clickmap = true;
        this.trackLinks = true;
        this.accurateTrackBounce = true;
        this.webvisor = false;
        this.trackHash = true;
        this.ut = 'noindex';
    }
    return YandexCounterConfig;
}());

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t;
    return { next: verb(0), "throw": verb(1), "return": verb(2) };
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var Metrika = (function () {
    /**
     * @param {?} injector
     */
    function Metrika(injector) {
        this.defaultCounterId = injector.get(DEFAULT_COUNTER_ID);
        this.counterConfigs = injector.get(YANDEX_COUNTERS_CONFIGS);
        this.positionToId = this.counterConfigs.map(function (config) { return config.id; });
    }
    /**
     * @param {?} id
     * @return {?}
     */
    Metrika.getCounterNameById = function (id) {
        return "yaCounter" + id;
    };
    /**
     * @param {?} id
     * @return {?}
     */
    Metrika.getCounterById = function (id) {
        return window[Metrika.getCounterNameById(id)];
    };
    /**
     * @param {?} extensions
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.addFileExtension = function (extensions, counterPosition) {
        return __awaiter(this, void 0, void 0, function () {
            var counter, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        counter.addFileExtension(extensions);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} url
     * @param {?=} options
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.extLink = function (url, options, counterPosition) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var counter, promise, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        promise = this.getCallbackPromise(options, url);
                        counter.extLink(url, options);
                        return [2 /*return*/, promise];
                    case 2:
                        error_2 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} url
     * @param {?=} options
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.file = function (url, options, counterPosition) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var counter, promise, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        promise = this.getCallbackPromise(options, url);
                        counter.file(url, options);
                        return [2 /*return*/, promise];
                    case 2:
                        error_3 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.getClientID = function (counterPosition) {
        var /** @type {?} */ counter = this.getCounterByPosition(counterPosition);
        if (counter && counter.reachGoal) {
            return counter.getClientID();
        }
        console.warn('Counter is still loading');
    };
    /**
     * @param {?} userId
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.setUserID = function (userId, counterPosition) {
        return __awaiter(this, void 0, void 0, function () {
            var counter, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        counter.setUserID(userId);
                        return [2 /*return*/, { userId: userId, counterPosition: counterPosition }];
                    case 2:
                        error_4 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} params
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.userParams = function (params, counterPosition) {
        return __awaiter(this, void 0, void 0, function () {
            var counter, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        counter.userParams(params);
                        return [2 /*return*/, { params: params, counterPosition: counterPosition }];
                    case 2:
                        error_5 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} params
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.params = function (params, counterPosition) {
        return __awaiter(this, void 0, void 0, function () {
            var counter, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        counter.userParams(params);
                        return [2 /*return*/, { params: params, counterPosition: counterPosition }];
                    case 2:
                        error_6 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.replacePhones = function (counterPosition) {
        return __awaiter(this, void 0, void 0, function () {
            var counter, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        counter.replacePhones();
                        return [2 /*return*/, { counterPosition: counterPosition }];
                    case 2:
                        error_7 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?=} options
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.notBounce = function (options, counterPosition) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var counter, promise, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        promise = this.getCallbackPromise(options, options);
                        counter.notBounce(options);
                        return [2 /*return*/, promise];
                    case 2:
                        error_8 = _a.sent();
                        console.warn('Counter is still loading');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} type
     * @param {?=} options
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.fireEvent = function (type, options, counterPosition) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var counter, promise, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        promise = this.getCallbackPromise(options, options);
                        counter.reachGoal(type, options.params, options.callback, options.ctx);
                        return [2 /*return*/, promise];
                    case 2:
                        error_9 = _a.sent();
                        console.error('error', error_9);
                        console.warn("'Event with type [" + type + "] can't be fired because counter is still loading'");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} url
     * @param {?=} options
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.hit = function (url, options, counterPosition) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var counter, promise, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.counterIsLoaded(counterPosition)];
                    case 1:
                        counter = _a.sent();
                        promise = this.getCallbackPromise(options, options);
                        counter.hit(url, options);
                        return [2 /*return*/, promise];
                    case 2:
                        error_10 = _a.sent();
                        console.warn("'Hit for page [" + url + "] can't be fired because counter is still loading'");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} options
     * @param {?} resolveWith
     * @return {?}
     */
    Metrika.prototype.getCallbackPromise = function (options, resolveWith) {
        return new Promise(function (resolve, reject) {
            var /** @type {?} */ optionsCallback = options.callback;
            options.callback = function () {
                optionsCallback && optionsCallback.call(this);
                resolve(resolveWith);
            };
        });
    };
    /**
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.counterIsLoaded = function (counterPosition) {
        var /** @type {?} */ counter = this.getCounterByPosition(counterPosition);
        if (counter && counter.reachGoal) {
            return Promise.resolve(counter);
        }
        else {
            return Promise.reject(counter);
        }
    };
    /**
     * @param {?=} counterPosition
     * @return {?}
     */
    Metrika.prototype.getCounterByPosition = function (counterPosition) {
        var /** @type {?} */ counterId = this.getCounterIdByPosition(counterPosition);
        return Metrika.getCounterById(counterId);
    };
    /**
     * @param {?} counterPosition
     * @return {?}
     */
    Metrika.prototype.getCounterIdByPosition = function (counterPosition) {
        return (counterPosition === undefined)
            ? this.defaultCounterId
            : this.positionToId[counterPosition];
    };
    return Metrika;
}());
Metrika.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Metrika.ctorParameters = function () { return [
    { type: Injector, },
]; };

/**
 * @param {?} counterConfigs
 * @param {?=} defaultCounter
 * @return {?}
 */
function defaultCounterIdFactory(counterConfigs, defaultCounter) {
    return defineDefaultId(counterConfigs, defaultCounter);
}
/**
 * @param {?} counterConfigs
 * @param {?=} defaultCounter
 * @return {?}
 */
function defineDefaultId(counterConfigs, defaultCounter) {
    var /** @type {?} */ configs;
    if (counterConfigs instanceof Array) {
        configs = counterConfigs;
    }
    else {
        configs = [/** @type {?} */ (counterConfigs)];
    }
    var /** @type {?} */ defaultId;
    if (!defaultCounter) {
        defaultId = configs[0].id;
    }
    else if (typeof defaultCounter === 'number' && defaultCounter < configs.length) {
        defaultId = configs[defaultCounter].id;
    }
    else {
        defaultId = defaultCounter;
    }
    if (!defaultId) {
        console.warn('You provided wrong counter id as a default:', defaultCounter);
        return;
    }
    var /** @type {?} */ defaultCounterExists = false;
    var /** @type {?} */ config;
    for (var /** @type {?} */ i = 0; i < configs.length; i++) {
        config = configs[i];
        if (!config.id) {
            console.warn('You should provide counter id to use Yandex metrika counter', config);
            continue;
        }
        if (config.id === defaultId) {
            defaultCounterExists = true;
        }
    }
    if (!defaultCounterExists) {
        console.warn('You provided wrong counter id as a default:', defaultCounter);
    }
    return defaultId;
}
/**
 * @param {?} configs
 * @return {?}
 */
function countersFactory(configs) {
    return createConfigs(configs);
}
/**
 * @param {?} configs
 * @return {?}
 */
function createConfigs(configs) {
    var /** @type {?} */ counterConfigs;
    if (configs instanceof Array) {
        counterConfigs = configs;
    }
    else {
        counterConfigs = [/** @type {?} */ (configs)];
    }
    return counterConfigs.map(function (config) { return Object.assign(new YandexCounterConfig(), config); });
}
/**
 * @param {?} counterConfigs
 * @return {?}
 */
function appInitializerFactory(counterConfigs) {
    return insertMetrika.bind(null, counterConfigs);
}
/**
 * @param {?} counterConfigs
 * @return {?}
 */
function insertMetrika(counterConfigs) {
    var /** @type {?} */ name = 'yandex_metrika_callbacks';
    window[name] = window[name] || [];
    window[name].push(function () {
        try {
            for (var _i = 0, counterConfigs_1 = counterConfigs; _i < counterConfigs_1.length; _i++) {
                var config = counterConfigs_1[_i];
                createCounter(config);
            }
        }
        catch (e) { }
    });
    var /** @type {?} */ n = document.getElementsByTagName('script')[0];
    var /** @type {?} */ s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://mc.yandex.ru/metrika/watch.js';
    n.parentNode.insertBefore(s, n);
    return name;
}
/**
 * @param {?} config
 * @return {?}
 */
function createCounter(config) {
    window[getCounterNameById(config.id)] = new Ya.Metrika(config);
}
/**
 * @param {?} id
 * @return {?}
 */
function getCounterNameById(id) {
    return "yaCounter" + id;
}

var MetrikaModule = (function () {
    function MetrikaModule() {
    }
    /**
     * @param {?} configs
     * @param {?=} defaultCounterId
     * @return {?}
     */
    MetrikaModule.forRoot = function (configs, defaultCounterId) {
        return {
            ngModule: MetrikaModule,
            providers: [
                {
                    provide: DEFAULT_COUNTER_ID_AOT,
                    useValue: defaultCounterId,
                },
                {
                    provide: YANDEX_COUNTERS_CONFIGS_AOT,
                    useValue: configs,
                },
                {
                    provide: DEFAULT_COUNTER_ID,
                    useFactory: defaultCounterIdFactory,
                    deps: [YANDEX_COUNTERS_CONFIGS_AOT, DEFAULT_COUNTER_ID_AOT],
                },
                {
                    provide: YANDEX_COUNTERS_CONFIGS,
                    useFactory: countersFactory,
                    deps: [YANDEX_COUNTERS_CONFIGS_AOT],
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: appInitializerFactory,
                    deps: [YANDEX_COUNTERS_CONFIGS],
                    multi: true,
                },
                {
                    provide: Metrika,
                    useClass: Metrika,
                    deps: [Injector],
                }
            ],
        };
    };
    return MetrikaModule;
}());
MetrikaModule.decorators = [
    { type: NgModule, args: [{},] },
];
/**
 * @nocollapse
 */
MetrikaModule.ctorParameters = function () { return []; };

/**
 * Generated bundle index. Do not edit.
 */

export { MetrikaModule, Metrika, YandexCounterConfig, appInitializerFactory as ɵi, countersFactory as ɵg, createConfigs as ɵh, defaultCounterIdFactory as ɵe, defineDefaultId as ɵf, insertMetrika as ɵj, DEFAULT_COUNTER_ID as ɵb, DEFAULT_COUNTER_ID_AOT as ɵa, YANDEX_COUNTERS_CONFIGS as ɵd, YANDEX_COUNTERS_CONFIGS_AOT as ɵc };
//# sourceMappingURL=ng-yandex-metrika.es5.js.map



//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/ng-yandex-metrika/ng-yandex-metrika.es5.js
// module id = ../../../../ng-yandex-metrika/ng-yandex-metrika.es5.js
// module chunks = 8